import React, { useState } from "react";
import { Grommet, Box, ResponsiveContext } from 'grommet';
import { hpe } from 'grommet-theme-hpe';
import { Header, Notification, AgentSidebar, PageFooter } from './components';
import { Home } from './pages/home';
import { BPHome } from './pages/bp';
import { ChatHome } from './pages/chat';
import { ExecHome } from './pages/exec';
import { OrdersHome } from './pages/orders';
import { SPLHome } from './pages/spl';
import { TicketsHome } from './pages/tickets';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HeaderHeightProvider } from './utils/HeaderHeightContext';


function App() {

    // State to track if the agent dialog is expanded or collapsed
  const [isAgentExpanded, setIsAgentExpanded] = useState(false);

  // Toggle function to expand/collapse the agent
  const toggleAgent = () => {
    setIsAgentExpanded((prev) => !prev);
  };
  
  return (
    <HeaderHeightProvider> 
      <BrowserRouter>
        <Grommet className="App" theme={hpe} full>
          <ResponsiveContext.Consumer>
            {size => (
              <Box fill background="background-back" direction="column" style={{ height: '100vh' }}>

                {/* Header */}
                <Box width="100%" elevation="medium" flex={false}>
                  <Header toggleAgent={toggleAgent} />
                </Box>

                {/* Main Content */}
                <Box flex="grow" overflow="auto">
                  <Notification />
                  <Box margin={{ top: 'xxsmall' }} direction="row" flex="grow" >
                    <Box flex={true} overflow="auto">
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/bp" element={<BPHome />} />
                        <Route path="/support/chat" element={<ChatHome />} />
                        <Route path="/exec" element={<ExecHome />} />
                        <Route path="/orders" element={<OrdersHome />} />
                        <Route path="/spl" element={<SPLHome />} />
                        <Route path="/support/tickets" element={<TicketsHome />} />
                        <Route path="*" element={<Home />} />
                      </Routes>  
                    </Box>
                    <AgentSidebar isAgentExpanded={isAgentExpanded} />
                  </Box>
                </Box>

                {/* Footer */}
                <Box width="100%" flex={false}>
                  <PageFooter />
                </Box>

              </Box>
            )}
          </ResponsiveContext.Consumer>
        </Grommet>
      </BrowserRouter>
    </HeaderHeightProvider>
  );
}

export default App;
